import { humanizeErrors } from "../helpers/hasErrors";

export default class HandsInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = { value: this.props.value };
  }

  translateToHands = ({target: {value}}) => {
    this.setState({value: value % 1 >= 0.4 ? _.ceil(value) : value});
  }

  render() {
    const {label, required, placeholder, updateField, fieldName, error=[], has_errors} = this.props;
    const {value} = this.state;
    const requiredField = required ? '*' : null;
    return (
      <div className={classnames("form-group", {error: error.length})}>
        <label>{label} {requiredField}</label>
        <div className={classnames('error-message', {has_errors})}>
          {humanizeErrors(error)}
        </div>
        <div className="input-group">
          <input type="number"
            name={fieldName}
            value={value ? value : ''}
            className="form-control"
            placeholder={placeholder}
            min={0}
            max={24.3}
            onChange={this.translateToHands}
            onBlur={updateField}/>
          <div className="input-group-append">
            <span className="input-group-text">hands</span>
          </div>
        </div>
      </div>
    )
  }
}
